import { Outlet } from "@tanstack/react-router";
import { Leaf, Lock } from "lucide-react";
import "../modules/auth/styles/login.css";

export function AuthLayout() {
  return (
    <div className="auth-shell">
      <main className="auth-container">
        <section className="auth-brand-panel">
          <div className="auth-curve auth-curve-top" />
          <div className="auth-curve auth-curve-bottom" />

          <div className="auth-brand-content">
            <div className="auth-brand-title">Bienvenido a</div>

            <div className="auth-brand-logo">
              <Leaf size={62} />
            </div>

            <h1 className="auth-title">INPRONEXUS</h1>

            <div className="auth-brand-line" />

            <p className="auth-subtitle">
              Plataforma empresarial para centralizar operaciones internas,
              RRHH, IT y documentación corporativa.
            </p>

            <div className="auth-brand-footer">
              <span>INPRONEXUS</span>
              <span className="auth-brand-divider" />
              <span className="auth-secure-footer">
                <Lock size={13} />
                Acceso seguro
              </span>
            </div>
          </div>
        </section>

        <section className="auth-form-panel">
          <Outlet />
        </section>
      </main>
    </div>
  );
}